if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');

      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute("data-vendor") == "Billi") {
        if (document.querySelector('.intercom-launcher')) {
          document.querySelector('.intercom-launcher').click()
        }
        return;
      }

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');
      
      const formData = new FormData(this.form);
      

      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      let form = Object.fromEntries(formData.entries())
      let cart_items = []
      let temp = {
        id: form.id,
        quantity: form.quantity,
        properties: {}
      }
      
      
      let item_keys = []
      let variant_select = document.querySelector("variant-picker")
      let relate_on_id = [parseInt(form.id)]
      if (variant_select) {
        
        if (variant_select.querySelector('[name="note"]')) {
          if (variant_select.querySelector('[name="note"]').value) {
            item_keys.push({
              "title": "note",
              "value": variant_select.querySelector('[name="note_title"]').value + variant_select.querySelector('[name="note"]').value
            })
          }
          
        }
        if (variant_select.querySelectorAll(".related-product") && variant_select.querySelectorAll(".related-option")) {
  
          let related_products = [variant_select.querySelectorAll(".related-product"), variant_select.querySelectorAll(".related-option")]
          for (let i = 0; i < related_products.length; i++) {     
            const related_product = related_products[i];
            for (let j = 0; j < related_product.length; j++) {
              
              let select_related = related_product[j].querySelectorAll("input:checked:not([value='None'])")
  
              
              let select_value = []
              for (let k = 0; k < select_related.length; k++) {
                select_value.push(select_related[k].title)
                relate_on_id.push(parseInt(select_related[k].value))
                cart_items.push({
                  "id": select_related[k].value,
                  "quantity": form.quantity,
                  "properties": {}
                })
              }
              if (select_value.length > 0) {
                
                item_keys.push({
                  "title": select_related[0].name.replace("option-relate-", "").split("-")[0].replaceAll("_", " ").replace(/\b\w/g, char => char.toUpperCase()),
                  "value": select_value.join(" + ")
                })
              }
            }
          }
        }
      }

      
      
      let properties = {}
      if (item_keys.length > 0) {
        for (let i = 0; i < item_keys.length; i++) {
          properties[item_keys[i]["title"]] = item_keys[i]["value"]
        }
        properties._relate_on = relate_on_id
      }
      cart_items.push(temp)
      


      if (properties) {        
        for (let i = 0; i < cart_items.length; i++) {
          cart_items[i].properties = properties
        }
      }

      delete form.id
      delete form.quantity
      form['items'] = cart_items

      // -- fetchRequestOpts --

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        let oldCartData = await oldCartResponse.json();

        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(form)
        };

        
        let product_id = form['product-id']
        let spc_product_id = 8176189145260
        
        let spc_product = oldCartData.items.filter((item) => item.product_id == spc_product_id)
        let spc_flag = false

        if (spc_product.length > 0 && parseInt(product_id) == spc_product_id) {
          await fetch(theme.routes.cartChange, {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: spc_product[0].id+"",
              quantity: 0
            })
          });
        }else if (spc_product.length > 0) {
          spc_flag = true
        }

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
            
            if (spc_flag) {
              setTimeout(() => {
                let cur_type = spc_product[0]["variant_options"][0]
                let cur_btn = document.querySelector(`button[data-extended-type = "${cur_type}"]`)
                let cur_id = cur_btn.parentElement.querySelector('input[name="id"]').value
                if (cur_btn && cur_id+"" != spc_product[0].id+"") {
                  cur_btn.click()
                }
              });
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        
        
        
        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }

      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
